import { getConfig } from "../_configs/AppConfig";

export function getApiBaseUrl(): string {
  const { publicRuntimeConfig } = getConfig();
  return publicRuntimeConfig.API_SPEC_URL.replace(/\/?schema-oas\.json$/, "");
}
